var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _vm.type == "list"
        ? [
            _c(
              "el-card",
              { staticClass: "normal-page" },
              [
                _vm.search.length > 0
                  ? _c("oaFromBox", {
                      attrs: {
                        isAddBtn: true,
                        isViewSearch: false,
                        search: _vm.search,
                        title: "排班管理",
                        total: _vm.total,
                      },
                      on: {
                        addDataFn: _vm.addFn,
                        confirmData: _vm.confirmData,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "table-box mt10" },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.tableData, height: _vm.tableHeight },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "排班月份" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm
                                            .$moment(scope.row.date)
                                            .format("yyyy年MM月")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3894561612
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "考勤组名称", prop: "group.name" },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "考勤组成员",
                            prop: "position",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    row.group.members.length <= 3
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                row.group.members
                                                  .map(function (obj) {
                                                    return obj.name
                                                  })
                                                  .join("、")
                                              ) +
                                              "\n              "
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              row.group.members
                                                .slice(0, 3)
                                                .map(function (obj) {
                                                  return obj.name
                                                })
                                                .join("、")
                                            ) +
                                              " 等" +
                                              _vm._s(row.group.members.length) +
                                              " 人"
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4272200711
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            fixed: "right",
                            label: "操作",
                            width: "180",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.group.is_delete !== 1
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "hr:attendance:schedul:edit",
                                                ],
                                                expression:
                                                  "['hr:attendance:schedul:edit']",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editFn(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("排班")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.group.is_delete == 1
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.checkFn(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("查看")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: [
                                              "hr:attendance:schedul:copy",
                                            ],
                                            expression:
                                              "['hr:attendance:schedul:copy']",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyFn(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("复制")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4063055117
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "page-fixed" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.where.page,
                            "page-size": _vm.where.limit,
                            "page-sizes": [15, 20, 30],
                            total: _vm.total,
                            layout: "total,sizes, prev, pager, next, jumper",
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.pageChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("oa-dialog", {
        ref: "oaDialog",
        attrs: {
          formConfig: _vm.formConfig,
          formDataInit: _vm.formDataInit,
          formRules: _vm.formRules,
          fromData: _vm.fromData,
        },
        on: { submit: _vm.submit },
      }),
      _vm._v(" "),
      _vm.type == "add"
        ? _c("add-schedul", {
            attrs: { id: _vm.id, newData: _vm.newData },
            on: { backFn: _vm.backFn },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.type == "check"
        ? _c("check-schedul", {
            attrs: { id: _vm.id, newData: _vm.newData },
            on: { backFn: _vm.backFn },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }